var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "calendar-workspace"
  }, [_c('div', {
    staticClass: "calendar-heading"
  }, [_c('div', {
    staticClass: "calendar-heading__title"
  }, [_c('span', {
    staticClass: "calendar-heading__icon"
  }, [_c('app-icon', {
    attrs: {
      "name": "calendar",
      "size": 23
    }
  })], 1), _c('div', [_c('div', {
    staticClass: "calendar-eyebrow"
  }, [_vm._v("Online konzultácie")]), _c('h2', [_vm._v(_vm._s(_vm.consultationClient ? "Term\xEDn pre ".concat(_vm.consultationClient.first_name, " ").concat(_vm.consultationClient.last_name) : 'Kalendár'))])])]), _c('button', {
    staticClass: "calendar-icon-button calendar-close",
    attrs: {
      "type": "button",
      "aria-label": "Zavrieť kalendár",
      "title": "Zavrieť kalendár"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "close",
      "size": 20
    }
  })], 1)]), _c('div', {
    staticClass: "calendar-toolbar"
  }, [_c('div', {
    staticClass: "calendar-date-controls"
  }, [_c('button', {
    staticClass: "calendar-today-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToday
    }
  }, [_vm._v("Dnes")]), _c('div', {
    staticClass: "calendar-arrows"
  }, [_c('button', {
    staticClass: "calendar-icon-button",
    attrs: {
      "type": "button",
      "aria-label": _vm.mode === 'Day' ? 'Predchádzajúci deň' : 'Predchádzajúci týždeň'
    },
    on: {
      "click": _vm.previousWeek
    }
  }, [_c('app-icon', {
    staticClass: "calendar-arrow-back",
    attrs: {
      "name": "arrow-right",
      "size": 18
    }
  })], 1), _c('button', {
    staticClass: "calendar-icon-button",
    attrs: {
      "type": "button",
      "aria-label": _vm.mode === 'Day' ? 'Nasledujúci deň' : 'Nasledujúci týždeň'
    },
    on: {
      "click": _vm.nextWeek
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "arrow-right",
      "size": 18
    }
  })], 1)]), _c('strong', {
    staticClass: "calendar-range",
    attrs: {
      "aria-live": "polite"
    }
  }, [_vm._v(_vm._s(_vm.dateRange))])]), _c('div', {
    staticClass: "calendar-toolbar__actions"
  }, [!_vm.compact ? _c('div', {
    staticClass: "calendar-view-switch",
    attrs: {
      "aria-label": "Zobrazenie kalendára"
    }
  }, [_c('button', {
    attrs: {
      "type": "button",
      "aria-pressed": _vm.mode === 'WorkWeek'
    },
    on: {
      "click": function click($event) {
        return _vm.setView('WorkWeek');
      }
    }
  }, [_vm._v("Týždeň")]), _c('button', {
    attrs: {
      "type": "button",
      "aria-pressed": _vm.mode === 'Day'
    },
    on: {
      "click": function click($event) {
        return _vm.setView('Day');
      }
    }
  }, [_vm._v("Deň")])]) : _vm._e(), _c('button', {
    staticClass: "calendar-create-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.openConsultation();
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "plus",
      "size": 18
    }
  }), _c('span', [_vm._v(_vm._s(_vm.consultationClient ? 'Zadať termín' : 'Nová konzultácia'))])], 1)])]), _c('div', {
    staticClass: "calendar-grid-card"
  }, [_c('div', {
    staticClass: "calendar-day-headers",
    style: {
      gridTemplateColumns: "52px repeat(".concat(_vm.visibleDays.length, ", minmax(0, 1fr))")
    }
  }, [_c('div', {
    staticClass: "calendar-timezone",
    attrs: {
      "title": "Miestny čas"
    }
  }, [_vm._v("Čas")]), _vm._l(_vm.visibleDays, function (day) {
    return _c('div', {
      key: day.key,
      staticClass: "calendar-day",
      "class": {
        'is-today': day.today
      }
    }, [_c('span', [_vm._v(_vm._s(day.weekday))]), _c('strong', [_vm._v(_vm._s(day.number))]), day.today ? _c('small', [_vm._v("dnes")]) : _vm._e()]);
  })], 2), _c('div', {
    ref: "canvas",
    staticClass: "calendar-canvas"
  }, [_c('div', {
    attrs: {
      "id": "calendar",
      "aria-label": "Termíny v kalendári"
    }
  })])]), _c('div', {
    staticClass: "calendar-footer"
  }, [_c('span', {
    staticClass: "calendar-selection-hint"
  }, [_c('app-icon', {
    attrs: {
      "name": "plus",
      "size": 14
    }
  }), _vm._v(" Vyber voľný čas v kalendári a vytvor konzultáciu.")], 1), _vm._m(0)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "calendar-legend"
  }, [_c('span', [_c('i', {
    staticClass: "calendar-legend__meeting"
  }), _vm._v("Dohodnuté")]), _c('span', [_c('i', {
    staticClass: "calendar-legend__available"
  }), _vm._v("Voľné termíny")])]);

}]

export { render, staticRenderFns }